import moment from 'moment-timezone';
import { HelperService } from '../helper.service';

export class ViewDashboardContract {
	public contractId: string;
	public contractNum: string;
	public rfqSessionId: string;
	public dbaName: string;
	public serviceTypeId: string;
	public stateId: string;
	public stateLong: string;
	public utilityId: string;
	public utilityName: string;
	public isResidential: boolean;
	public status: number;
	public displayStatus: string;
	public rate: number;
	public displayPtc: string;
	public displayPtcRaw: number;
	public displayPreviousContractRate: string;
	public displayPreviousContractRateRaw: number;
	public displayBaseRateOverride: string;
	public displayBaseRateOverrideRaw: number;
	public displayIndicativeRate: string;
	public displayIndicativeRateRaw: number;
	public submissionStatus: number;
	public submissionStatusAutoSubmittedDate: string;
	public annualUsage: number;
	public baseRateOverride: number;
	public baseRateCurrencyUnits: string;
	public previousContractRate: number;
	public units: string;
	public marginUnits: string;
	public rejectReason: string;
	public rejectReasonSubCategoryId: number;
	public depositRequiredAmount: number;
	public companyId: string;
	public isSaas: boolean;
	public effectiveDate: Date;
	public expirationDate: Date;
	public ptc: number;
	public indicativeRate: number;
	public isPurchasingLayerContract: boolean;
	public confirmationDate: Date;
	public isRenewal: boolean;
	public isExternalRenewal: boolean;
	public isNewCustomer: boolean;
	public isCurrentPriceEditable: boolean;
	public isRenewalProspect: boolean;
	public agentId: string;
	public agentName: string;
	public customerId: string;
	public parentId: string;
	public brotherId: string;
	public previousContractExpirationMonth: string;
	public contractDate: Date;
	public displayAnnualUsage: number;
	public supplierId: string;
	public supplierName: string;
	public currentPrice: number;
	public displayCurrentPrice: string;
	public displayCurrentPriceRaw: number;
	public showDepositRequiredMessage: boolean;
	public showHoldSubmissionStatus: boolean;
	public showAutoSubmissionStatus: boolean;
	public fitsAboutLayeredPurchasingReq: boolean;
	public isRejectedCommercial: boolean;
	public isAboveUsageThreshold: boolean;
	public showRequestPrice: boolean;
	public showStatusButton: boolean;
	public showStatusNoButton: boolean;
	public symbol: string;
	public symbol2: string;
	public isNewBrokerAuction: boolean;
	public agentIsNewBroker: boolean;
	public parentName: string;
	/** Always in $/kWh or $/therm. Apply rateToUnits + marginUnits correction when displaying. */
	public bestDelta: number;
	public bestDeltaLabel: string;
	public isPriceVsCurrentPricePositive: boolean;
	public enterpriseName: string;
	public enterpriseId: number;

	// internal properties
	public editingCurrentPrice: boolean;
	public savingCurrentPrice: boolean;
	public displayContractNum: string;
	public displayAgentName: string;

	constructor(viewDashboardContract?: Partial<ViewDashboardContract>) {
		Object.assign(this, viewDashboardContract);

		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY hh:mm:ss a')) : this.effectiveDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY hh:mm:ss a')) : this.expirationDate;
		this.contractDate = this.contractDate ? new Date(moment(this.contractDate).format('MMM DD, YYYY hh:mm:ss a')) : this.contractDate;

		this.displayContractNum = HelperService.showAsteriskForContractFirstImpression(Number(this.status), this.isNewBrokerAuction)
			? this.contractNum + '*'
			: this.contractNum;

		this.displayAgentName = HelperService.showAsteriskForBrokerFirstImpression(this.agentIsNewBroker) ? this.agentName + '*' : this.agentName;
	}
}
